import { render, staticRenderFns } from "./projectRegistration.vue?vue&type=template&id=731a6bf9&scoped=true"
import script from "./projectRegistration.vue?vue&type=script&lang=js"
export * from "./projectRegistration.vue?vue&type=script&lang=js"
import style0 from "./projectRegistration.vue?vue&type=style&index=0&id=731a6bf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731a6bf9",
  null
  
)

export default component.exports